import { render, staticRenderFns } from "./CheckBalance.vue?vue&type=template&id=4a6f0db3&scoped=true&"
import script from "./CheckBalance.vue?vue&type=script&lang=js&"
export * from "./CheckBalance.vue?vue&type=script&lang=js&"
import style0 from "./CheckBalance.vue?vue&type=style&index=0&id=4a6f0db3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6f0db3",
  null
  
)

export default component.exports